import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { AUTH } from '@constants/routes';
import AuthLayout from '@layouts/auth-layout/AuthLayout_V2';
import AccessGuard from '@contexts/AccessGuard';
import { RoleType } from '@types';
import authBackground from '@assets/images/auth/non_auth_background.webp';

const LoginPage = lazy(() => import('./pages/login/Login'));

const MascotSelection = lazy(
  () => import('./pages/mascot-selection/MascotSelection')
);

const SubjectSelection = lazy(
  () => import('./pages/subject-selection/SubjectSelection')
);

export const AuthRoutes: RouteObject = {
  children: [
    {
      element: <AuthLayout />,
      children: [{ path: AUTH.LOGIN, element: <LoginPage /> }]
    },
    {
      element: <AuthLayout variant="center" backgroundImage={authBackground} />,
      children: [
        {
          path: AUTH.MASCOT_SELECTION,
          element: (
            <AccessGuard role={RoleType.STUDENT}>
              <MascotSelection />
            </AccessGuard>
          )
        }
      ]
    },
    {
      element: <AuthLayout variant="center" backgroundImage={authBackground} />,
      children: [
        {
          path: AUTH.SUBJECT_SELECTION,
          element: (
            <AccessGuard role={RoleType.STUDENT}>
              <SubjectSelection />
            </AccessGuard>
          )
        }
      ]
    }
  ]
};

export default AuthRoutes;
